import { useQuery } from "react-query";
import { axiosPost } from "../../lib/axiosClient";

const useSeasonActivitys = (
  country_id,
  exam_board_id,
  subject_id,
  year_id,
  season,
  page
) => {
  const formData = {};
  if (country_id) formData.country_id = country_id;
  if (exam_board_id) formData.exam_board_id = exam_board_id;
  if (subject_id) formData.subject_id = subject_id;
  if (year_id) formData.year_id = year_id;
  if (season) formData.chapter_id = season;

  if (page) {
    formData.pagination = true;
    formData.page = page;
  }

  formData.test_type = "season_activity";

  return useQuery(
    [
      "seasonActivitis",
      country_id,
      exam_board_id,
      subject_id,
      year_id,
      season,
      page,
    ],
    async () => {
      const { data } = await axiosPost("/api/cw/viewQuestion", formData);
      return data;
    },
    {
      refetchOnWindowFocus: false,
    }
  );
};

export default useSeasonActivitys;
